// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"169":"d87a0624","396":"94d72cd8","402":"d87a0624","464":"d87a0624","516":"69ebad10","752":"d87a0624"}[chunkId] + ".chunk.css";
};